var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',_vm._l((_vm.batchJobResults),function(item,itemCount){return _c('div',{key:`item${itemCount}`},[(item.reportComponentName)?_c(item.reportComponentName,{tag:"component",attrs:{"reportData":item.data,"onError":_vm.saveError}}):_vm._e()],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }